import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PublicFooter = () => {
  const [content, setContent] = useState(null);

  const defaults = {
    tagline: 'Enterprise-level marketing expertise with a personal, collaborative approach. Helping businesses elevate their marketing since 2024.',
    copyright_text: 'SPT Digital Marketing LLC. All rights reserved.'
  };

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/public/site-content/footer`);
        if (response.data && Object.keys(response.data).length > 0) {
          setContent(response.data);
        }
      } catch (err) {
        // Use defaults
      }
    };
    fetchContent();
  }, []);

  const c = { ...defaults, ...content };

  // Use CSS variables from StyleProvider
  const footerStyle = {
    backgroundColor: 'var(--color-footer-bg, #0F172A)',
    color: 'var(--color-footer-text, #94A3B8)'
  };

  return (
    <footer className="py-16" style={footerStyle}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <img 
              src="/spt-logo.png" 
              alt="SPT Digital Marketing" 
              className="h-16 w-auto mb-6 brightness-0 invert"
            />
            <p className="mb-6 max-w-md" style={{ color: 'var(--color-footer-text, #94A3B8)' }}>
              {c.tagline}
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-3" style={{ color: 'var(--color-footer-text, #94A3B8)' }}>
              <li><Link to="/services" className="footer-link hover:text-white transition-all duration-200 inline-block">Services</Link></li>
              <li><Link to="/portfolio" className="footer-link hover:text-white transition-all duration-200 inline-block">Portfolio</Link></li>
              <li><Link to="/blog" className="footer-link hover:text-white transition-all duration-200 inline-block">Insights</Link></li>
              <li><Link to="/contact" className="footer-link hover:text-white transition-all duration-200 inline-block">Contact</Link></li>
              <li><Link to="/about" className="footer-link hover:text-white transition-all duration-200 inline-block">About</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-white">Contact</h4>
            <ul className="space-y-3" style={{ color: 'var(--color-footer-text, #94A3B8)' }}>
              <li>Southport, NC</li>
              <li>
                <a href="mailto:info@sptdigitalmarketing.com" className="hover:text-white transition-colors">
                  info@sptdigitalmarketing.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm" style={{ color: 'var(--color-footer-text, #94A3B8)' }}>
          <p>© {new Date().getFullYear()} {c.copyright_text}</p>
          <div className="flex gap-6 mt-4 md:mt-0 flex-wrap justify-center">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" className="hover:text-white transition-colors">Cookie Policy</Link>
            <Link to="/cookie-policy" className="hover:text-white transition-colors" data-testid="your-privacy-choices-link">Your Privacy Choices</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
